export default __webpack_public_path__ + "static/media/kitchen1.386c2afb.jpg";